export default __webpack_public_path__ + "assets/c9082214ee79e7ae9139d26bbc8683c8.png";